import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { loadConfig } from '@/config/configLoader';
import { getMsalConfig } from '@/auth/msalConfig';
import '@/localization/i18n';

async function bootstrap() {
  await loadConfig();

  // Initialize MSAL before mounting React so handleRedirectPromise runs
  // and tokens are stored before any component checks isAuthenticated.
  const msalInstance = new PublicClientApplication(getMsalConfig());
  await msalInstance.initialize();

  const { default: App } = await import('@/app/App');

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <App msalInstance={msalInstance} />,
  );
}

bootstrap().catch((err) => {
  console.error('Failed to bootstrap application:', err);
  document.getElementById('root')!.innerHTML =
    '<div style="padding:40px;font-family:sans-serif;color:#dc2626">Failed to load application configuration.</div>';
});
